import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { Navigation } from '../../Navigation';

type MatchLeftNavBarProps = {
  navList: {
    icon: JSX.Element;
    counter: number;
    hash: string;
    title: string;
    isError: boolean;
}[]
};

const MatchLeftNavBar = ({
  navList,
}: MatchLeftNavBarProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const [isOpenNav, setIsOpenNav] = useState<boolean>(true);

  const handleOpenNavClick = () => {
    setIsOpenNav(!isOpenNav);
  };

  return (
    <Navigation
      title={ translate(STRING_KEYS.TITLE_NAVIGATION, { title: 'Talents' }) }
      navList={ navList }
      onOpenNavClick={ handleOpenNavClick }
      isOpenNav={ isOpenNav }
    />
  );
};

export default React.memo(MatchLeftNavBar);
